import { Box, Skeleton, Theme, Typography, useMediaQuery } from '@mui/material'

import { MembershipInterval } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'

import {
  DigitalMembershipCard,
  DigitalMembershipCardData,
} from '../DigitalMembershipCard'

export interface DigitalMembershipCardPreviewProps {
  digitalMembershipCard: Pick<
    DigitalMembershipCardData,
    'cardDesignPath' | 'textColor' | 'displayAreaColor'
  >
  loading?: boolean
  // 未設定時にマスクを非表示にするかどうか（未指定の場合はマスクを表示）
  hideMask?: boolean
}

export const DigitalMembershipCardPreview: React.FC<DigitalMembershipCardPreviewProps> =
  ({ digitalMembershipCard, loading = false, hideMask = false }) => {
    const { t } = useTranslation('digitalMembershipCardPreview')
    const smUp = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'))

    return (
      <Box sx={{ mb: 4, py: 3 }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: 600,
            mx: 'auto',
            backgroundColor: '#F5F5F5',
            borderRadius: 2,
            border: '1px solid #E0E0E0',
            p: smUp ? 3 : 2,
          }}
        >
          {/* プレビュータイトル */}
          <Typography
            variant="body2"
            sx={{
              color: '#9E9E9E',
              fontSize: '13px',
              fontWeight: 300,
              mb: 2,
            }}
          >
            {t('preview')}
          </Typography>

          <Box
            sx={{
              width: '100%',
              mx: 'auto',
              aspectRatio: '856/540',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              px: '8px',
            }}
          >
            {loading ? (
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={{ borderRadius: 2 }}
              />
            ) : digitalMembershipCard.cardDesignPath || hideMask ? (
              <DigitalMembershipCard
                cardDesignPath={digitalMembershipCard.cardDesignPath}
                textColor={digitalMembershipCard.textColor}
                displayAreaColor={digitalMembershipCard.displayAreaColor}
                displayName={t('exampleDisplayName')}
                membershipNumber={t('exampleMembershipNumber')}
                planInterval={MembershipInterval.Month}
                joinDate={t('exampleJoinDate')}
                favoriteMemberCreatedAt={t('exampleJoinDate')}
                loading={loading}
              />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: 'auto',
                  aspectRatio: '856/540',
                  border: '2px dashed #ccc',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f9f9f9',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: '#999',
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  {t('notSet')}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    )
  }
